/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData, postData, deleteData } from "utils/Gateway";
import VatOptions from "data/Invoice/VAT.json";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { getCurrentDateInString } from "helper/getcurrentdatestring";
import SaveInvoiceSuccessModal from "../Modal/SaveInvoiceSuccessModal";
import NoteSection from "../NoteComponent/NoteSection";
import { reactSelectStyle } from "Config/Config";
import HistoryCard from "../HistoryCard/HistoryCard";

const SaveInvoiceForm = ({
  leadId = null,
  contactId = null,
  contactPersonId = null,
  moduleSlug,
  moduleName,
}) => {
  const params = useParams();
  const history = useHistory();

  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [followersInput, setFollowersInput] = useState("");
  const [followersOptions, setFollowersOptions] = useState([]);
  const [invoiceModuleName, setInvoiceModuleName] = useState(moduleName || "");
  const [invoiceContactId, setinvoiceContactId] = useState(contactId);
  const [invoiceLeadId, setinvoiceLeadId] = useState(leadId);
  const [invoiceContactPersonId, setinvoiceContactPersonId] =
    useState(contactPersonId);
  const [ownerName, setownerName] = useState("");
  const [title, settitle] = useState("");
  const [description, setdescription] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [promisePercent, setpromisePercent] = useState("");
  const [followersValue, setFollowersValue] = useState(null);
  const [selctedFollowers, setSelectedFollowers] = useState([]);
  const [totalTax, setTotalTax] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [invoiceOwnerId, setinvoiceOwnerId] = useState(null);
  const [selectedInvoiceId, setselectedInvoiceId] = useState(null);

  const invoiceItemTemplate = {
    _id: null,
    description: "",
    quantity: 0,
    price: 0,
    discountpercent: 0,
    discount: 0,
    taxpercent: 0,
    tax: 0,
    amount: 0,
    taxselectedvalue: null,
  };

  const [invoiceItemsList, setInvoiceItemsList] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  // Validation states from AddNewCrmOpportunityPopup
  const [errors, setErrors] = useState({});

  //requirements of leads/contacts
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [emailAddress, setemailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [company, setcompany] = useState("");
  const [position, setposition] = useState("");
  const [address, setaddress] = useState("");
  const [city, setcity] = useState("");
  const [state, setstate] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [noteAccessUserList, setnoteAccessUserList] = useState([]);
  const [invoiceHistory, setInvoiceHistory] = useState([]);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Validation function from AddNewCrmOpportunityPopup
  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) {
      newErrors.title = t("Title is required");
    }
    if (!totalAmount || totalAmount <= 0) {
      newErrors.price = t("Price must be calculated and greater than 0");
    }
    if (!promisePercent || promisePercent <= 0) {
      newErrors.percent = t("Promise Percent must be greater than 0");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onFollowersInputChange = (val) => setFollowersInput(val);

  const getFollowersOptions = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_USERLIST_OPTIONS}?userstringinput=${followersInput}`;
      const response = await getData(requestUrl);
      if (response.status) setFollowersOptions(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const getInvoiceHistory = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_INVOICE_HISTORY}?invoiceid=${params.invoiceid}`;
      const response = await getData(requestUrl);
      if (response.status) setInvoiceHistory(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };

  const followersSelectionHandler = (val) => {
    setFollowersValue(val);
    setSelectedFollowers(val ? val.map((item) => item.value) : []);
  };

  const addNewInvoiceItem = () =>
    setInvoiceItemsList([...invoiceItemsList, invoiceItemTemplate]);

  const onDeleteInvoiceItem = (index) => {
    const deletedItemBlock = [...invoiceItemsList];
    deletedItemBlock.splice(index, 1);
    setInvoiceItemsList(deletedItemBlock);
  };

  const updateInvoiceBlock = (invoiceItems) => {
    const invoiceItemsArr = invoiceItems.map((item) => ({
      _id: item._id ?? null,
      description: item.description ?? "",
      quantity: item.unit ?? 0,
      price: item.price ?? 0,
      discountpercent: item.discountpercent ?? 0,
      discount: item.discountamount ?? 0,
      taxpercent: item.taxpercent ?? 0,
      tax: item.taxamount ?? 0,
      amount: item.totalprice ?? 0,
      taxselectedvalue: getTaxSelectedSelectOptionValue(item.taxpercent),
    }));
    setInvoiceItemsList(invoiceItemsArr);
  };

  const changeInvoiceItemsInputs = (index, field, value) => {
    const updatedFormValues = invoiceItemsList.map((block, i) =>
      index === i ? { ...block, [field]: value } : block
    );
    setInvoiceItemsList(updatedFormValues);
  };

  const taxSelectionHandler = (index, val) => {
    const updatedFormValues = invoiceItemsList.map((block, i) =>
      index === i
        ? { ...block, taxselectedvalue: val, taxpercent: val.value }
        : block
    );
    setInvoiceItemsList(updatedFormValues);
  };

  const invoiceItemUpdateHandler = () => {
    const totalAmount = invoiceItemsList.reduce(
      (acc, item) => acc + (item.price || 0) * (item.quantity || 0),
      0
    );
    const totalTax = invoiceItemsList.reduce(
      (acc, item) => acc + (item.tax || 0),
      0
    );
    const totalDiscount = invoiceItemsList.reduce(
      (acc, item) => acc + (item.discount || 0),
      0
    );
    const payableAmount = invoiceItemsList.reduce(
      (acc, item) => acc + (item.amount || 0),
      0
    );

    setTotalAmount(totalAmount);
    setTotalTax(totalTax);
    setTotalDiscount(totalDiscount);
    setPayableAmount(payableAmount);
    if (totalAmount > 0 && errors.price) {
      setErrors((prev) => ({ ...prev, price: "" }));
    }
  };

  const getTaxSelectedSelectOptionValue = (val) =>
    VatOptions.find((option) => option.value === val?.toString()) || null;

  const updateItemGrossValues = (index) => {
    const updatedItems = [...invoiceItemsList];
    const quantity = parseInt(updatedItems[index].quantity, 10) || 0;
    const price = parseInt(updatedItems[index].price, 10) || 0;
    const tax = parseInt(updatedItems[index].taxpercent, 10) || 0;
    if (quantity > 0 && price > 0) {
      const taxToPay = (quantity * price * tax) / 100;
      const totalPrice = quantity * price + taxToPay;
      updatedItems[index].tax = taxToPay;
      updatedItems[index].amount = totalPrice;
      setInvoiceItemsList(updatedItems);
    }
  };

  useEffect(() => {
    invoiceItemsList.forEach((_, index) => updateItemGrossValues(index));
  }, [
    invoiceItemsList
      .map((item) => `${item.quantity}-${item.price}-${item.taxpercent}`)
      .join(","),
  ]);

  const getInvoiceDetails = async () => {
    let requestUrl = `${url.API_BASE_URL}${url.API_INVOICE_DETAILS}/${params.invoiceid}`;
    try {
      const response = await getData(requestUrl);
      if (response.status) {
        const { data } = response;
        setInvoiceModuleName(data.modulename || moduleName || "");
        setinvoiceLeadId(data.leadid?._id || null);
        setinvoiceContactPersonId(data.client?._id || null);
        settitle(data.title);
        setdescription(data.description);
        setpromisePercent(data.promisepercent);
        followersSelectionHandler(data.followerslist);
        if (data.invoiceitems?.length > 0) {
          updateInvoiceBlock(data.invoiceitems);
        } else {
          setTotalAmount(data.amount);
        }
        setinvoiceOwnerId(data.user._id);
        setownerName(data.ownername);
        if (data.leadid) getLeadDetails(data.leadid._id);
        if (data.client) getContactUserDetails(data.client._id);
        if (data.contactid) setinvoiceContactId(data.contactid);
        const allFollowerIds = data.followers?.map((item) => item._id) || [];
        const appendedNoteFollowers = [...allFollowerIds, data.user._id];
        setnoteAccessUserList(
          appendedNoteFollowers.filter(
            (id) => id.toString() !== userInfo._id.toString()
          )
        );
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  const saveInvoice = async () => {
    if (!validateForm()) {
      return;
    }
    setIsSaving(true);
    let invoiceData = {
      leadid: invoiceLeadId || leadId,
      contactid: invoiceContactId || contactId,
      clientid: invoiceContactPersonId || contactPersonId,
      title,
      description,
      amount: totalAmount,
      promisepercent: promisePercent,
      followers: selctedFollowers,
      invoicedate: getCurrentDateInString(),
      duedate: getCurrentDateInString(),
      totaltax: totalTax,
      totaldiscount: totalDiscount,
      payableamount: payableAmount,
      currency: "euro",
      items: invoiceItemsList,
      status: "1",
      notes: [],
      typeslug: moduleSlug,
      modulename: invoiceModuleName,
    };

    let requestUrl = url.API_BASE_URL;
    let response = {};

    try {
      if (params.invoiceid) {
        requestUrl += `${url.API_UPDATE_INVOICE}/${params.invoiceid}`;
        response = await putData(requestUrl, invoiceData);
      } else {
        requestUrl += `${url.API_CREATE_INVOICE}`;
        response = await postData(requestUrl, invoiceData);
      }
      setIsSaving(false);
      if (response.status) {
        setselectedInvoiceId(response.data._id);
        setMessageType("success");
        setTimeout(() => {
          const bootstrapModal = new bootstrap.Modal(
            document.getElementById("afterSaveInvoiceModal")
          );
          bootstrapModal.show();
        }, 1000);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const resetHandler = () => {
    setErrors({});
    settitle("");
    setdescription("");
    setpromisePercent("");
    setInvoiceItemsList([invoiceItemTemplate]);
    setTotalAmount(0);
    setTotalTax(0);
    setPayableAmount(0);
    setFollowersInput("");
    setFollowersOptions([]);
    setFollowersValue(null);
  };

  const getLeadDetails = async (leadId) => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_LEAD_DETAILS}/${leadId}`;
      const response = await getData(requestUrl);
      if (response.status) {
        const {
          name,
          surname,
          email,
          phone,
          dob,
          company,
          position,
          address,
          city,
          state,
          country,
          zipcode,
        } = response.data;
        setfirstName(name);
        setlastName(surname);
        setemailAddress(email);
        setPhoneNumber(phone);
        setDateOfBirth(
          dob?.includes("-") ? dob.split("-").reverse().join("-") : ""
        );
        setcompany(company ?? "");
        setposition(position ?? "");
        setaddress(address ?? "");
        setcity(city ?? "");
        setstate(state ?? "");
        setcountry(country ?? "");
        setzipcode(zipcode ?? "");
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  const getContactUserDetails = async (userId) => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_USER_DETAILS}/${userId}`;
      const response = await getData(requestUrl);
      if (response.status && response.data) {
        const {
          name,
          surname,
          email,
          phone,
          dob,
          company,
          position,
          address,
          city,
          state,
          country,
          zipcode,
        } = response.data;
        setfirstName(name);
        setlastName(surname);
        setemailAddress(email);
        setPhoneNumber(phone);
        setDateOfBirth(
          dob?.includes("-") ? dob.split("-").reverse().join("-") : ""
        );
        setcompany(company ?? "");
        setposition(position ?? "");
        setaddress(address ?? "");
        setcity(city ?? "");
        setstate(state ?? "");
        setcountry(country ?? "");
        setzipcode(zipcode ?? "");
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    if (!params.invoiceid) addNewInvoiceItem();
  }, []);

  useEffect(() => {
    if (params.invoiceid) {
      getInvoiceHistory();
      getInvoiceDetails();
    }
  }, [params.invoiceid]);

  useEffect(() => {
    if (invoiceItemsList.length > 0) invoiceItemUpdateHandler();
  }, [invoiceItemsList]);

  useEffect(() => {
    if (followersInput.length > 0) getFollowersOptions();
  }, [followersInput]);

  const afterSuccessModalClose = (responseType) => {
    let path = "/admin/crm/opportunity/list";
    if (responseType === "list") {
      if (moduleName === "lead")
        path = `/admin/crm/lead/opportunities/${params.id}`;
      else if (moduleName === "contact")
        path = `/admin/crm/contact/details/opportunities/${params.id}`;
    } else if (responseType === "details") {
      path = `/admin/crm/opportunity/save/${
        selectedInvoiceId || params.invoiceid
      }`;
      if (moduleName === "lead")
        path = `/admin/crm/lead/opportunity/save/${params.id}/${selectedInvoiceId}`;
      else if (moduleName === "contact")
        path = `/admin/crm/contact/opportunity/save/${params.id}/${selectedInvoiceId}`;
      getInvoiceDetails();
    }
    history.push(path);
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const followersOptionsToShow =
    followersOptions.length > 0 ? followersOptions : [];
  const isOwner =
    !params.invoiceid ||
    (invoiceOwnerId && invoiceOwnerId.toString() === userInfo._id.toString());

  return (
    <div className="row">
      <div
        className={`mb-4 mb-lg-0 ${
          params.invoiceid ? "col-lg-8" : "col-lg-12"
        }`}
      >
        <div className="create-lead-container p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {ownerName && (
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                    {t("Moderator")}
                  </label>
                  <p className="form-control fs-sm shadow-none border border-gray-300">
                    {ownerName}
                  </p>
                </div>
              )}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="title"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Title")}
                </label>
                <input
                  type="text"
                  id="title"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("Enter opportunity title")}
                  value={title}
                  onChange={(e) => {
                    settitle(e.target.value);
                    if (errors.title)
                      setErrors((prev) => ({ ...prev, title: "" }));
                  }}
                />
                {errors.title && (
                  <div className="invalid-feedback">{errors.title}</div>
                )}
              </div>
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="description"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Description")}
                </label>
                <textarea
                  id="description"
                  rows="5"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t("Enter a detailed description")}
                  value={description}
                  onChange={(e) => setdescription(e.target.value)}
                ></textarea>
              </div>
              <div className="row">
                <div className="col-3">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      {t("Price")}
                    </label>
                    <p
                      className={`form-control fs-sm shadow-none ${
                        errors.price ? "is-invalid" : "border border-gray-300"
                      }`}
                    >
                      {totalAmount}
                    </p>
                    {errors.price && (
                      <div className="invalid-feedback d-block">
                        {errors.price}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="promisePercent"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Promise Percent")}
                    </label>
                    <input
                      type="number"
                      id="promisePercent"
                      className={`form-control fs-sm shadow-none ${
                        errors.percent ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("e.g., 80")}
                      value={promisePercent}
                      onChange={(e) => {
                        setpromisePercent(e.target.value);
                        if (errors.percent)
                          setErrors((prev) => ({ ...prev, percent: "" }));
                      }}
                    />
                    {errors.percent && (
                      <div className="invalid-feedback">{errors.percent}</div>
                    )}
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label className="d-block fs-sm fw-semibold mb-2 text-dark">
                      {t("Followers")}
                    </label>
                    <Select
                      isMulti
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      placeholder={t("Type followers name or email")}
                      options={followersOptionsToShow}
                      value={followersValue}
                      onChange={followersSelectionHandler}
                      onInputChange={onFollowersInputChange}
                    />
                  </div>
                </div>
              </div>
              <div className="table-wrapper pb-5 mb-5 border-bottom border-gray">
                <div className="table-responsive mb-1">
                  <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
                    <thead>
                      <tr>
                        <th
                          width="40%"
                          className="bg-transparent fs-md fw-semibold border-0"
                        >
                          {t("Description")}
                        </th>
                        <th className="bg-transparent fs-md fw-semibold border-0">
                          {t("Quantity")}
                        </th>
                        <th className="bg-transparent fs-md fw-semibold border-0">
                          {t("Price")}
                        </th>
                        <th
                          width="15%"
                          className="bg-transparent fs-md fw-semibold border-0"
                        >
                          {t("Tax (IVA)")}
                        </th>
                        <th className="bg-transparent fs-md fw-semibold border-0">
                          {t("Total Amount")}
                        </th>
                        <th className="bg-transparent fs-md fw-semibold border-0"></th>
                      </tr>
                    </thead>
                    <tbody style={{ height: "200px" }}>
                      {invoiceItemsList.map((item, index) => (
                        <tr key={index} style={{ verticalAlign: "top" }}>
                          <td className="border-bottom-0 p-1">
                            <input
                              type="text"
                              placeholder={t("e.g., Product description")}
                              className="form-control bg-white shadow-none border-gray-300"
                              value={item.description}
                              onChange={(e) =>
                                changeInvoiceItemsInputs(
                                  index,
                                  "description",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className="border-bottom-0 p-1">
                            <input
                              type="number"
                              placeholder={t("e.g., 1")}
                              className="form-control bg-white shadow-none border-gray-300"
                              value={item.quantity}
                              onChange={(e) =>
                                changeInvoiceItemsInputs(
                                  index,
                                  "quantity",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className="border-bottom-0 p-1">
                            <input
                              type="number"
                              placeholder={t("e.g., 100")}
                              className="form-control bg-white shadow-none border-gray-300"
                              value={item.price}
                              onChange={(e) =>
                                changeInvoiceItemsInputs(
                                  index,
                                  "price",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className="border-bottom-0 p-0">
                            <Select
                              placeholder="IVA %"
                              className="w-100 mt-1"
                              styles={reactSelectStyle(
                                "5px",
                                "6px",
                                false,
                                false
                              )}
                              options={VatOptions}
                              value={item.taxselectedvalue}
                              onChange={(val) =>
                                taxSelectionHandler(index, val)
                              }
                            />
                          </td>
                          <td className="border-bottom-0 p-1">
                            <span className="form-control bg-white shadow-none border-gray-300">
                              {item.amount}
                            </span>
                          </td>
                          <td className="action border-bottom-0">
                            <Link
                              to="#"
                              className="text-danger"
                              onClick={() => onDeleteInvoiceItem(index)}
                            >
                              <span className="d-block material-symbols-outlined">
                                delete
                              </span>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {isOwner && (
                  <div className="action d-flex gap-1">
                    {" "}
                    <button
                      className="btn btn-outline-primary d-flex align-items-center gap-2"
                      onClick={addNewInvoiceItem}
                    >
                      <span className="material-symbols-outlined me-1">
                        add
                      </span>
                      {t("Add Item")}
                    </button>
                    <button
                      className="btn btn-primary ms-3 d-flex align-items-center gap-2"
                      onClick={saveInvoice}
                      disabled={isSaving}
                      style={{
                        cursor: isSaving ? "not-allowed" : "pointer",
                      }}
                    >
                      {isSaving ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          {t("Saving...")}
                        </>
                      ) : (
                        <>
                          <span className="material-symbols-outlined me-1">
                            save
                          </span>
                          {t("Save Opportunity")}
                        </>
                      )}
                    </button>
                  </div>
                )}
              </div>
              <div className="table-wrapper pb-3 mb-3 border-bottom border-gray">
                <div className="table-responsive">
                  <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
                    <tbody>
                      <tr>
                        <td className="p-0 fw-semibold bg-transparent border-0">
                          {t("Total Discount")}
                        </td>
                        <td className="p-0 bg-transparent text-end border-0">
                          {totalDiscount}€
                        </td>
                      </tr>
                      <tr>
                        <td className="p-0 fw-semibold bg-transparent border-0">
                          {t("Total Tax (VAT)")}
                        </td>
                        <td className="p-0 bg-transparent text-end border-0">
                          {totalTax}€
                        </td>
                      </tr>
                      <tr>
                        <td className="p-0 fs-lg fw-semibold bg-transparent border-0">
                          {t("Total Payable Amount")}
                        </td>
                        <td className="p-0 fs-lg fw-semibold text-success bg-transparent text-end border-0">
                          {payableAmount}€
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </form>
          <SaveInvoiceSuccessModal
            moduleType="opportunity"
            afterSuccessModalClose={afterSuccessModalClose}
          />
        </div>
      </div>
      {params.invoiceid && (
        <div className="col-lg-4">
          <NoteSection
            noteAccessUserList={noteAccessUserList}
            invoiceId={params.invoiceid}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          {/* Lead/Contact Information Section */}
          <div className="mt-4 note-card bg-white border border-gray-300 rounded-15 mb-3 shadow-sm position-relative overflow-hidden">
            <div
              className="px-4 py-3 border-bottom border-gray-300"
              style={{
                background:
                  "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <span className="material-symbols-outlined text-white fs-md">
                    person
                  </span>
                </div>
                <div>
                  <h4 className="fw-bold mb-1 text-dark">
                    {invoiceLeadId ? t("Lead") : t("Contact")}{" "}
                    {t("Information")}
                  </h4>
                  <p className="fs-sm text-muted mb-0">
                    {t("Details of the associated")}{" "}
                    {invoiceLeadId ? t("lead") : t("contact")}
                  </p>
                </div>
              </div>
            </div>
            <div className="note-content pt-4 px-4 pb-4">
              <div className="d-flex align-items-center gap-2 mb-2">
                <span className="material-symbols-outlined fs-sm text-muted">
                  badge
                </span>
                <small className="text-muted fw-semibold">
                  {t("Name")} :{" "}
                  <Link
                    to={
                      invoiceLeadId
                        ? `/admin/crm/lead/information/${invoiceLeadId}`
                        : `/admin/crm/contact/details/timeline/${invoiceContactId}`
                    }
                  >
                    {firstName} {lastName}
                  </Link>
                </small>
              </div>
              <p
                className="text-dark lh-base mb-0"
                style={{ fontSize: "0.95rem" }}
              >
                <span className="material-symbols-outlined fs-sm text-muted me-2">
                  mail
                </span>
                <strong>{t("Email")} : </strong> {emailAddress}
              </p>
              <p
                className="text-dark lh-base mb-0"
                style={{ fontSize: "0.95rem" }}
              >
                <span className="material-symbols-outlined fs-sm text-muted me-2">
                  phone
                </span>
                <strong>{t("Phone")} : </strong> {phoneNumber}
              </p>
              <p
                className="text-dark lh-base mb-0"
                style={{ fontSize: "0.95rem" }}
              >
                <span className="material-symbols-outlined fs-sm text-muted me-2">
                  cake
                </span>
                <strong>{t("Date of birth")} : </strong> {dateOfBirth}
              </p>
              {position && (
                <p
                  className="text-dark lh-base mb-0"
                  style={{ fontSize: "0.95rem" }}
                >
                  <span className="material-symbols-outlined fs-sm text-muted me-2">
                    work
                  </span>
                  <strong>{t("Position")} : </strong> {position}{" "}
                  {company && `at ${company}`}
                </p>
              )}
              <p
                className="text-dark lh-base mb-0"
                style={{ fontSize: "0.95rem" }}
              >
                <span className="material-symbols-outlined fs-sm text-muted me-2">
                  location_on
                </span>
                <strong>{t("Location")} : </strong> {address}
                {city && `, ${city}`}
                {state && `, ${state}`}
                {country && `, ${country}`}
                {zipcode && `, ${zipcode}`}
              </p>
            </div>
          </div>

          {/* History Section */}
          <div className="mt-4 bg-white border border-gray-300 rounded-15 shadow-lg overflow-hidden">
            <div
              className="px-4 py-3 border-bottom border-gray-300"
              style={{
                background:
                  "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "40px", height: "40px" }}
                >
                  <span className="material-symbols-outlined text-white fs-md">
                    history
                  </span>
                </div>
                <div>
                  <h4 className="fw-bold mb-1 text-dark">{t("History")}</h4>
                  <p className="fs-sm text-muted mb-0">
                    {t("Recent changes and updates")}
                  </p>
                </div>
              </div>
            </div>
            <div className="p-4">
              {invoiceHistory.length > 0 ? (
                <div className="notes-container">
                  {invoiceHistory.map((historyItem, index) => (
                    <HistoryCard historyItem={historyItem} t={t} key={index} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <div
                    className="p-4 bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <span
                      className="material-symbols-outlined text-muted"
                      style={{ fontSize: "2rem" }}
                    >
                      history
                    </span>
                  </div>
                  <h6 className="fw-bold text-muted mb-2">
                    {t("No History Yet")}
                  </h6>
                  <p className="text-muted mb-0">
                    {t("Changes will appear here")}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          alertType={messageType}
          message={alertMessage}
          onClose={onAlertClose}
        />
      )}
    </div>
  );
};

export default SaveInvoiceForm;
